import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { actionCreators } from 'dux/instances';
import BackupList from './BackupList';

const propTypes = {
  instanceId: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  getBackups: PropTypes.func.isRequired,
  backups: PropTypes.instanceOf(Array).isRequired,
  getPitrBackupStatus: PropTypes.func.isRequired,
  pitrBackupInfo: PropTypes.shape({
    message: PropTypes.string,
    lastSnapshotTimeStamp: PropTypes.string,
    lastPitrChunkTimeStamp: PropTypes.string,
    state: PropTypes.number,
    status: PropTypes.string,
  }),
};

class BackupListContainer extends React.Component {
  componentDidMount() {
    const { instanceId, instanceService, getBackups, getPitrBackupStatus } = this.props;
    getBackups(instanceId, instanceService);
    if (instanceService === "MongoDB") {
      getPitrBackupStatus(instanceId, instanceService);
    }
  }

  render() {
    return <BackupList {...this.props} />;
  }
}

BackupListContainer.propTypes = propTypes;
BackupListContainer.defaultProps = {
  pitrBackupInfo: {},
};

const mapDispatchToProps = {
  getBackups: actionCreators.getBackups,
  getPitrBackupStatus: actionCreators.getPitrBackupStatus,
};

export default connect(null, mapDispatchToProps)(BackupListContainer);
